import IconCirculeDefendant from "./IconCirculeDefendant.vue";
export default IconCirculeDefendant